export const PICKER_SELECTION_TYPE = {
  COMBO: 'combo',
  JUST_SUB: 'just-sub',
};
